import { useState } from 'react';
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from 'react-router';
import * as S from './styles';
//components
import ToastConfirmSale from '../../../Toast/ConfirmSale';
import FormsCart from '../Forms';
import SelectProduct from '../SelectProduct';
//context
import { useCart } from "context/CartContex";
//icons
import { Minus, X } from '@phosphor-icons/react';
//hooks
import apiRequest from '../../../../hooks/apiRequest';
//utils
import { CurrencyFormat, formatPercentage } from 'utils/CurrencyFormat';
import FormatarData from 'utils/FormatData';

interface FormsCartProps {
    isOpenFormsCart: boolean;
    setIsOpenFormsCart: (isOpen: boolean) => void;
}

export type Inputs = {
    number_ata: string;
    customer_id: number,
    user_id: number,
    payment_method_id: number,
    items: [],
    date_sale: string,
}

export default function LayoutOrder({
    isOpenFormsCart,
    setIsOpenFormsCart }: FormsCartProps) {

    const {
        register,
        handleSubmit,
        setValue,
        resetField,
    } = useForm<Inputs>();

    const {
        state,
        clearCart
    } = useCart();

    const navigate = useNavigate();
    const [isOpenModalProduct, setIsOpenModalProduct] = useState(true);

    //Dados do Toast
    const [toastOpen, setToastOpen] = useState(false);
    const [toastError, setToastError] = useState('');
    const [toastMessager, seToastMessager] = useState({
        count: 0,
        message: ''
    })

    // Função para FECHAR o formulário
    const handleCloseForm = () => {
        setIsOpenFormsCart(false);
    };

    // Função para LIMPAR o formulário
    const handleClearForm = () => {
        handleCloseForm();
        clearCart();
    };

    // Função para FECHAR ou VOLTAR o formulário
    const handleFormsButton = () => {
        //CANECELAR Venda
        if (isOpenModalProduct) {
            handleClearForm();
        } else {
            //VOLTAR Venda
            setIsOpenModalProduct(true);
        }
    };

    // Função para enviar o formulário
    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        if (isOpenModalProduct) {
            setIsOpenModalProduct(false);
        } else {
            setToastOpen(true);
            seToastMessager({
                count: 1,
                message: 'Preparando o pedido'
            })
            try {
                const payload = {
                    number_ata: data.number_ata || null,
                    customer_id: Number(data.customer_id || state.customer?.id) || null,
                    seller_id: Number(data.user_id) || null,
                    date_sale: data.date_sale || null,

                    items: state.items.map(item => ({
                        type: item.type === 'accessories' ? 'accessory' : item.type,
                        id: Number(item.id) || null,
                        quantity: item.quantity,
                        promotions: item.promotions && item.promotions.promotion_id ? [  // força array
                            {
                                promotion_id: Number(item.promotions.promotion_id),
                                paymentable_type: item.promotions.paymentable_type,
                                paymentable_id: Number(item.promotions.paymentable_id),
                                personalized_discount: Number(item.promotions.personalized_discount || 0)
                            }
                        ] : null,

                        payments: (item.payments || []).map(pay => ({
                            payment_method_id: pay.payment_method_id,
                            amount: pay.amount || 0,

                            // se crédito
                            ...((pay.name === 'crédito' || pay.name === 'cartão de crédito') && {
                                installment_on_credit_card_id: pay.installment_on_credit_card_id || undefined,
                            }),

                            // se crediário
                            ...((pay.name === 'crediário' || pay.name === 'crediário da loja') && {
                                down_payment: pay.down_payment || undefined,
                                down_payments: pay.down_payments || [],
                                first_due_date: pay.first_due_date || undefined,
                                payment_credit_installment: pay.payment_credit_installment || undefined,
                            })

                        }))
                    }))
                };

                seToastMessager({
                    count: 2,
                    message: 'Validando Pagamentos'
                })

                const response = await apiRequest("save-sale", "POST", payload);
                if (response.status === 201) {
                    seToastMessager({
                        count: 3,
                        message: 'Finalizado'
                    })
                    seToastMessager({
                        count: 4,
                        message: 'Venda cadastrada com sucesso'
                    })
                    handleClearForm();
                    navigate('venda');
                }
            } catch (error: any) {
                setToastError(error.message || "Erro ao salvar venda.");
                console.log('error', error);
                return null;
            }
        }
    };

    const CalcProduct = (amount: any | number, quantity: number) => {
        const valor = amount || 0;
        const quantidade = quantity || 1;
        const result = valor * quantidade;
        return result || 0;
    }

    const CalcProductDiscount = (amount: any | number, discount: any) => {
        const valor = amount || 0;
        const desconto = Number(discount || 0);
        const result = valor * desconto / 100;
        return result || 0;
    }

    if (isOpenFormsCart) {
        return (
            <S.Container>
                <S.Content>
                    <S.Header>
                        <S.ContentBloc>
                            <S.Text className="title">Carrinho de Compras</S.Text>
                            <S.Text className="subtitle">Revise os produtos antes de finalizar o pedido</S.Text>
                        </S.ContentBloc>

                        <S.ContentButton>
                            <S.Button onClick={handleCloseForm}>
                                <Minus size={20} />
                            </S.Button>
                            <S.Button onClick={handleClearForm}>
                                <X size={20} />
                            </S.Button>
                        </S.ContentButton>
                    </S.Header>

                    <S.Body onSubmit={handleSubmit(onSubmit)}>
                        <S.Forms>
                            {
                                isOpenModalProduct ?
                                    <SelectProduct />
                                    :
                                    <FormsCart
                                        register={register}
                                        setValue={setValue}
                                        resetField={resetField}
                                    />

                            }
                        </S.Forms>

                        <S.FormActions>
                            <S.ContentInfor>
                                <S.Text>Resumo</S.Text>

                                {/* Descrição do Comprador */}
                                <S.SectionProduct>
                                    {/* <S.Infor>
                                        <S.Text className='infor-subtitle'>Data da venda:</S.Text>
                                        <S.Text className='infor-subtitle'>{state.data?.date || '-'}</S.Text>
                                    </S.Infor> */}

                                    <S.Infor>
                                        <S.Text className='infor-subtitle'>Cliente:</S.Text>
                                        <S.Text className='infor-subtitle'>
                                            {state.data?.customer?.full_name || ''} ({state.data?.customer?.cpf || 'xxx.xxx.xxx-xx'})
                                        </S.Text>
                                    </S.Infor>

                                    {/* <S.Infor>
                                        <S.Text className='infor-subtitle'>Vendedor:</S.Text>
                                        <S.Text className='infor-subtitle'>
                                            {state.data?.seller?.first_name || '-'}
                                        </S.Text>
                                    </S.Infor> */}

                                    {/* <S.Infor>
                                        <S.Text className='infor-subtitle'>Nº da venda:</S.Text>
                                        <S.Text className='infor-subtitle'>{state.data?.number_order || '-'}</S.Text>
                                    </S.Infor> */}
                                </S.SectionProduct>

                                {/* Descrição do Produto */}
                                <S.SectionProduct>
                                    <S.InforProduct className='infor-border'>
                                        <S.Text>Descrição</S.Text>
                                        <S.Text>Total</S.Text>
                                    </S.InforProduct>

                                    {
                                        state.items.map((item) => {
                                            const discount = item.promotions?.personalized_discount || 0;
                                            return (
                                                <S.ContentProduct>
                                                    <S.Text className='subtitle'>{item.code || '-'}</S.Text>
                                                    <S.InforProduct>
                                                        <S.Text className='subtitle'>{item.quantity || '0'}x {CurrencyFormat(item.price || 0)}</S.Text>

                                                        <S.Text>{CurrencyFormat(CalcProduct(item.price, item.quantity))}</S.Text>
                                                    </S.InforProduct>

                                                    <S.InforProduct>
                                                        <S.Text className='subtitle'>Desconto</S.Text>
                                                        <S.Text className='subtitle'>
                                                            {
                                                                CurrencyFormat(CalcProductDiscount(item.price, discount))
                                                            }
                                                        </S.Text>
                                                    </S.InforProduct>

                                                    {
                                                        item.payments ? item.payments.map((pay) => (
                                                            <S.ContentBloc>
                                                                <S.InforProduct>
                                                                    <S.Text className='subtitle'>
                                                                        {(pay.name || '-').toLocaleUpperCase()}
                                                                        {pay.parcela > 0 ? `(${pay.parcela || 0}x)` : null}
                                                                    </S.Text>

                                                                    <S.Text className='subtitle'>
                                                                        {
                                                                            CurrencyFormat(parseFloat(pay.amount || '0'))
                                                                        }
                                                                    </S.Text>
                                                                </S.InforProduct>

                                                                {
                                                                    Number(pay.taxa) > 0 ?
                                                                        <S.InforProduct>
                                                                            <S.Text className='subtitle'>
                                                                                Taxa
                                                                            </S.Text>

                                                                            {
                                                                                Number(pay.taxa) > 0 ?
                                                                                    <S.Text className='subtitle'>
                                                                                        +{formatPercentage(parseFloat(pay.taxa || '0'))}
                                                                                    </S.Text> :
                                                                                    null
                                                                            }
                                                                        </S.InforProduct>
                                                                        : null
                                                                }

                                                                {
                                                                    (pay.name === 'crediário' || pay.name === 'crediário da loja') &&
                                                                    <S.ContentBloc className='sub-content'>
                                                                        <S.InforProduct>
                                                                            <S.Text className='subtitle'>
                                                                                Receber
                                                                            </S.Text>

                                                                            <S.Text className='subtitle'>
                                                                                {CurrencyFormat(parseFloat(pay.to_receive || '0'))}
                                                                            </S.Text>
                                                                        </S.InforProduct>

                                                                        {
                                                                            pay.down_payments && pay.down_payments.map((val: any, index: number) => (
                                                                                <S.ContentBloc>
                                                                                    <S.InforProduct>
                                                                                        <S.Text className='subtitle'>
                                                                                            {index + 1}: {val.name_payment || '-'}
                                                                                        </S.Text>

                                                                                        <S.Text className='subtitle'>
                                                                                            {CurrencyFormat(val.amount || 0)}
                                                                                        </S.Text>
                                                                                    </S.InforProduct>

                                                                                    {
                                                                                        Number(val.installment_interest_rate) > 0 ?
                                                                                            <S.InforProduct>
                                                                                                <S.Text className='subtitle'>
                                                                                                    Taxa
                                                                                                </S.Text>

                                                                                                {
                                                                                                    Number(val.installment_interest_rate) > 0 ?
                                                                                                        <S.Text className='subtitle'>
                                                                                                            +{formatPercentage(parseFloat(val.installment_interest_rate || '0'))}
                                                                                                        </S.Text> :
                                                                                                        null
                                                                                                }
                                                                                            </S.InforProduct>
                                                                                            : null
                                                                                    }
                                                                                </S.ContentBloc>

                                                                            ))
                                                                        }

                                                                        <S.InforProduct>
                                                                            <S.Text className='subtitle'>
                                                                                Data de Vencimento
                                                                            </S.Text>

                                                                            <S.Text className='subtitle'>
                                                                                {FormatarData(pay.first_due_date, 'default-data')}
                                                                            </S.Text>
                                                                        </S.InforProduct>

                                                                        <S.InforProduct>
                                                                            <S.Text className='subtitle'>
                                                                                Qtd. Parcelas
                                                                            </S.Text>

                                                                            <S.Text className='subtitle'>
                                                                                {pay.payment_credit_installment || 0}
                                                                            </S.Text>
                                                                        </S.InforProduct>
                                                                    </ S.ContentBloc >
                                                                }

                                                            </S.ContentBloc>
                                                        )) : null
                                                    }

                                                    <S.InforProduct>
                                                        <S.Text className='subtitle'>Subtotal</S.Text>
                                                        <S.Text className='subtitle'>
                                                            {CurrencyFormat(item.paymentsSubtotal || (item.price * item.quantity))}
                                                        </S.Text>

                                                    </S.InforProduct>
                                                </S.ContentProduct>
                                            )
                                        })
                                    }
                                </S.SectionProduct>

                                {/* Descrição de Valores */}
                                <S.SectionProduct>
                                    <S.Infor>
                                        <S.Text className='infor-subtitle'>Subtotal:</S.Text>
                                        <S.Text className='infor-subtitle'>
                                            {CurrencyFormat(state.subtotal || 0)}
                                        </S.Text>
                                    </S.Infor>
                                    <S.Infor>
                                        <S.Text className='infor-subtitle'>Desconto:</S.Text>
                                        <S.Text className='infor-subtitle'>
                                            {CurrencyFormat(state.discount || 0)}
                                        </S.Text>
                                    </S.Infor>
                                    <S.Infor>
                                        <S.Text>TOTAL A PAGAR:</S.Text>
                                        <S.Text>
                                            {CurrencyFormat(state.totalPrice || 0)}
                                        </S.Text>
                                    </S.Infor>
                                </S.SectionProduct>
                            </S.ContentInfor>

                            <S.ContentButton>
                                <S.Button
                                    onClick={handleFormsButton}
                                    className='close-button'
                                    type="button">
                                    {
                                        isOpenModalProduct ?
                                            'Cancelar'
                                            :
                                            'Voltar'
                                    }
                                </S.Button>
                                <S.Button
                                    onClick={handleSubmit(onSubmit)}
                                    className='submit-button'
                                    type="submit">
                                    {
                                        isOpenModalProduct ?
                                            'Continuar venda'
                                            :
                                            'Finalizar venda'
                                    }
                                </S.Button>
                            </S.ContentButton>
                        </S.FormActions>
                    </S.Body>

                    <ToastConfirmSale
                        isOpenModalToast={toastOpen}
                        setIsOpenModalToast={() => setToastOpen(false)}
                        error={toastError}
                        messagerCount={toastMessager}
                    />

                    <S.Text className="subtitle">
                        Atenção: Atenção: se você atualizar a página, os itens do seu carrinho serão apagados.
                    </S.Text>
                </S.Content>
            </S.Container>
        );
    }
    return null;
}